import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={16}
      height={15}
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path d="M8 10.4a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8z" fill="#FF7A00" />
      <Path
        d="M14.4 1.6h-2.536L10.872.52A1.593 1.593 0 009.696 0H6.304c-.448 0-.88.192-1.184.52L4.136 1.6H1.6C.72 1.6 0 2.32 0 3.2v9.6c0 .88.72 1.6 1.6 1.6h12.8c.88 0 1.6-.72 1.6-1.6V3.2c0-.88-.72-1.6-1.6-1.6zM8 12c-2.208 0-4-1.792-4-4s1.792-4 4-4 4 1.792 4 4-1.792 4-4 4z"
        fill="#FF7A00"
      />
    </Svg>
  );
}

export default SvgComponent;
